<script>
    import { theme } from '../stores.js';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    const toggleTheme = () => {
        dispatch('toggleTheme');
    }
</script>

<div class='container'>

    <div class="logo-container">
        <svg class="logo-image"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            width="104.72858mm"
            height="26.170259mm"
            viewBox="0 0 371.08553 92.729265"
            id="svg2"
            version="1.1"
            inkscape:version="0.91 r13725"
            sodipodi:docname="leaf_drawing.svg">
            <defs
                id="defs4">
                <linearGradient
                inkscape:collect="always"
                id="linearGradient4275">
                <stop
                    style="stop-color:#96d321;stop-opacity:1"
                    offset="0"
                    id="stop4277" />
                <stop
                    style="stop-color:#00a650;stop-opacity:1"
                    offset="1"
                    id="stop4279" />
                </linearGradient>
                <linearGradient
                inkscape:collect="always"
                xlink:href="#linearGradient4275"
                id="linearGradient4281"
                x1="302.81476"
                y1="234.23172"
                x2="572.89752"
                y2="234.23172"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(0.25208114,0,0,0.25208114,19.48088,130.18632)" />
            </defs>
            <sodipodi:namedview
                id="base"
                pagecolor="#ffffff"
                bordercolor="#666666"
                borderopacity="1.0"
                inkscape:pageopacity="0.0"
                inkscape:pageshadow="2"
                inkscape:zoom="2"
                inkscape:cx="224.29925"
                inkscape:cy="-3.7414682"
                inkscape:document-units="px"
                inkscape:current-layer="layer1"
                showgrid="false"
                inkscape:window-width="1920"
                inkscape:window-height="1026"
                inkscape:window-x="0"
                inkscape:window-y="1080"
                inkscape:window-maximized="1"
                fit-margin-top="0"
                fit-margin-left="0"
                fit-margin-right="0"
                fit-margin-bottom="0" />
            <metadata
                id="metadata7">
                <rdf:RDF>
                <cc:Work
                    rdf:about="">
                    <dc:format>image/svg+xml</dc:format>
                    <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                    <dc:title></dc:title>
                </cc:Work>
                </rdf:RDF>
            </metadata>
            <g
                inkscape:label="Layer 1"
                inkscape:groupmode="layer"
                id="layer1"
                transform="translate(-95.814767,-154.96295)">
                <path
                style="fill:url(#linearGradient4281);fill-opacity:1;stroke:currentcolor;stroke-width:0.25208113"
                d="m 158.79172,223.02382 c -13.06865,-1.60524 -24.56877,-6.10352 -34.96329,-13.67593 -10.15852,-7.40049 -17.96552,-17.46037 -22.84934,-29.44302 -1.65627,-4.06374 -3.25233,-9.54666 -3.81147,-13.09348 -0.45374,-2.8783 -0.89162,-6.66791 -1.04554,-9.04878 l -0.17282,-2.67299 0.8564,0.004 c 3.48011,0.0162 10.73476,1.00199 15.09897,2.05167 15.67398,3.76992 29.43513,13.12264 38.95584,26.47621 4.4589,6.25398 8.03627,13.32336 10.3255,20.40466 1.02602,3.17379 2.75313,10.02873 2.57231,10.20955 -0.0652,0.0652 -1.40343,-1.39026 -2.97389,-3.23432 -19.81357,-23.26548 -35.76498,-36.78187 -49.43593,-41.88941 -3.91106,-1.46119 -4.21541,-1.2091 -1.08236,0.89651 11.92135,8.01189 28.30649,23.55276 42.4851,40.29598 3.46486,4.09158 10.11878,12.24334 10.40145,12.7429 0.25023,0.44222 -0.60669,0.43759 -4.36093,-0.0236 z"
                id="path4227"
                inkscape:connector-curvature="0" />
                <text
                xml:space="preserve"
                style="font-style:normal;font-variant:normal;font-weight:200;font-stretch:normal;font-size:90px;line-height:125%;font-family:dosis;-inkscape-font-specification:'dosis Ultra-Light';letter-spacing:0px;word-spacing:0px;fill:currentcolor;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                x="193.5"
                y="226.36221"
                id="text4302"
                sodipodi:linespacing="125%"><tspan
                    sodipodi:role="line"
                    id="tspan4304"
                    x="193.5"
                    y="226.36221">leaf pool</tspan></text>
            </g>
        </svg>
    </div>

    <div class="phrase">a reliable and independent stake pool, est. 2019</div>
    
    <div class="toggle">
        {#if $theme == 'dark'}
            <svg on:click={toggleTheme} width="24" height="24" viewBox="0 0 24 24" style="cursor: pointer;"
                stroke="currentcolor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z" />
                <path class="icon" d="M12 1V3" />
                <path d="M12 21V23" />
                <path d="M4.21997 4.22L5.63997 5.64" />
                <path d="M18.36 18.36L19.78 19.78" />
                <path d="M1 12H3" />
                <path d="M21 12H23" />
                <path d="M4.21997 19.78L5.63997 18.36" />
                <path d="M18.36 5.64L19.78 4.22" />
            </svg>
        {:else}
            <svg on:click={toggleTheme} width="24" height="24" viewBox="0 0 24 24" style="cursor: pointer;"
                stroke="currentcolor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 12.79C20.8427 14.4922 20.2039 16.1144 19.1583 17.4668C18.1127 18.8192 16.7035 19.8458 15.0957 20.4265C13.4879 21.0073 11.748 
                21.1181 10.0795 20.7461C8.41104 20.3741 6.88302 19.5345 5.67425 18.3258C4.46548 17.117 3.62596 15.589 3.25393 13.9205C2.8819 12.252 2.99274 
                10.5121 3.57348 8.9043C4.15423 7.29651 5.18085 5.88737 6.53324 4.84175C7.88562 3.79614 9.50782 3.15731 11.21 3C10.2134 4.34827 9.73387 6.00945 
                9.85856 7.68141C9.98324 9.35338 10.7039 10.9251 11.8894 12.1106C13.075 13.2961 14.6466 14.0168 16.3186 14.1415C17.9906 14.2662 19.6518 13.7866 
                21 12.79V12.79Z" />
            </svg>
        {/if}
    </div>
</div>

<style>

    /*  
        load svg from file and set it as a mask to be able to change color
        https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-styles-with-css
        then use classes .toggle / .toggle-dark in svelte
    */

    /*
        TODO: use a single SVG image for toggle button
        OR show both images staked with sliding background
    */

    .container {
        padding-top: 40px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 2em;
    }

    .logo-container {
        width: min(100%, 30rem);   
        padding-left: 10px;
        padding-right: 44px;
    }

    .logo-image {
        width: 100%;
        height: auto;
    }

    .phrase {
        color: var(--clr-foreground-100);
        font-size: 0.7em;
        letter-spacing: 0.25em;
        font-weight: 300;
        margin-top: 1em;
    }

    .toggle {
        position: absolute;
        top: 10px;
        right: 10px;
        border: 1px solid rgba(var(--clr-foreground-csv),0.15);
        border-radius: 8px;
        max-height: 38px;
        padding: 6px;
    }


    /* PHONE */
    @media screen and (max-width: 480px)
    {

        /* TODO: reduce padding top in container */

        .logo-container {
            width: min(100%, 30rem);
            padding-left: 20px;
            padding-right: 50px;
        }

        .toggle {
            top: 3px;
            right: 3px;
            border-radius: 6px;
            max-height: 34px;
            padding: 4px;
        }

		.phrase {
            font-size: 0.6em;
            letter-spacing: 0.20em;
        }
	} 

</style>